(() => {
  const selector = '.section-wcn-header .wcn-mobile-details, .section-wcn-header .wcn-nav-details';
  const syncMenuLock = () => {
    const open = document.querySelector('.section-wcn-header .wcn-mobile-details[open], .section-wcn-header .wcn-shop-details[open]');
    document.documentElement.classList.toggle('wcn-menu-open', Boolean(open));
  };
  const closeMenu = (details, restoreFocus = true) => {
    if (!details) return;
    details.open = false;
    syncMenuLock();
    if (restoreFocus) details.querySelector('summary')?.focus();
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const close = event.target.closest('[data-wcn-menu-close]');
    if (close) closeMenu(close.closest('details'));
    const link = event.target.closest('.wcn-drawer a[href]');
    if (link) closeMenu(link.closest('details'), false);
    document.querySelectorAll('.section-wcn-header .wcn-nav-details[open]').forEach((details) => {
      if (!details.contains(event.target)) closeMenu(details, false);
    });
  });
  document.addEventListener('toggle', (event) => {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement) || !current.matches(selector)) return;
    if (current.open) {
      document.querySelectorAll(selector).forEach((details) => {
        if (details !== current) details.open = false;
      });
      if (current.matches('.wcn-mobile-details')) current.querySelector('[data-wcn-menu-close]')?.focus();
    }
    syncMenuLock();
  }, true);
  document.addEventListener('keydown', (event) => {
    const open = document.querySelector('.section-wcn-header details[open]');
    if (!open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu(open);
      return;
    }
    if (event.key !== 'Tab' || !open.matches('.wcn-mobile-details')) return;
    const focusable = [...open.querySelectorAll('.wcn-drawer a[href], .wcn-drawer button, .wcn-drawer input:not([type="hidden"])')]
      .filter((element) => !element.disabled && element.getClientRects().length > 0);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll(selector).forEach((details) => { details.open = false; });
    syncMenuLock();
  });
})();
